import { useCallback, useEffect } from "react";
import { Col, Container, Form, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import {
  getRegulationUrl,
  tradeInDevice,
} from "../../../../../../common/services/externalService.js";
import langs from "../../../../../../common/services/languageService.js";
import FormErrorMessage from "../../../../../ui/form-error-message/form-error-message.jsx";

const { labels, validationMessages } = langs;

function TradeInDevice({
  sourceAppType,
  requestProps,
  formSubmitProps,
  phoneNumber,
  transactionId,
  offerId,
}) {
  const { startRequest, finishRequest } = requestProps;
  const {
    setSubmitFn,
    handleSuccessfulSubmit,
    handleSubmitError,
    setButtonLabel,
    setButtonEnabled,
  } = formSubmitProps;
  const navigate = useNavigate();
  const {
    register,
    formState: { errors, isValid, isSubmitted },
    handleSubmit,
    setError,
  } = useForm({
    criteriaMode: "all",
    mode: "onChange",
  });

  useEffect(() => {
    setButtonLabel(labels.Next());
  }, [setButtonLabel]);

  const onSubmit = useCallback(
    (data) => {
      var payload = {
        ...data,
        phoneNumber: phoneNumber,
        transactionId: transactionId,
        offerId: offerId,
      };

      startRequest();
      tradeInDevice(payload, sourceAppType)
        .catch((err) => {
          console.error(err);
          navigate("/error");
        })
        .then((resp) => {
          finishRequest();
          let isRequestValid = true;

          if (!resp.data.isOfferAvailable) navigate("/no-offer");

          if (!resp.data.isDeviceNumberValid) {
            setError("deviceNumber", {
              type: "server",
              message: validationMessages.InvalidDeviceNumber(),
            });
            isRequestValid = false;
          }

          if (!resp.data.isPointOfSaleValid) {
            setError("storeCode", {
              type: "server",
              message: validationMessages.SalePointDoesntExist(),
            });

            isRequestValid = false;
          }

          if (!isRequestValid) {
            handleSubmitError();
            return;
          }

          handleSuccessfulSubmit();
        })
        .finally(() => finishRequest());
    },
    [],
  );

  const submitFn = useCallback(() => {
    return handleSubmit(onSubmit);
  }, [onSubmit, handleSubmit]);

  useEffect(() => {
    setSubmitFn(submitFn);
    return () => {
      setSubmitFn(null);
    };
  }, [submitFn]);

  useEffect(() => {
    setButtonEnabled(!isSubmitted || isValid);
  }, [setButtonEnabled, isValid, isSubmitted]);

  return (
    <Form className="ploom">
      <Container>
        <Row>
          <Col>
            <Form.Group>
              <Form.Label htmlFor="deviceNumber">
                {labels.EnterOwnedDeviceNumber()}
                <span>*</span>
              </Form.Label>
              <Form.Control
                id="deviceNumber"
                {...register("deviceNumber", {
                  required: validationMessages.Required(),
                  pattern: {
                    value: /^(.{12}|.{15})$/,
                    message: validationMessages
                      .FixedLength()
                      .replace("{0}", "12 lub 15"),
                  },
                })}
              />
              {isSubmitted && (
                <FormErrorMessage
                  formControlName={"deviceNumber"}
                  errors={errors}
                ></FormErrorMessage>
              )}
            </Form.Group>
          </Col>
        </Row>
        {sourceAppType == null && (
          <Row>
            <Col>
              <Form.Group>
                <Form.Group>
                  <Form.Label htmlFor="storeCode">
                    {labels.StoreCode()}
                    <span>*</span>
                  </Form.Label>
                  <Form.Control
                    id="storeCode"
                    {...register("storeCode", {
                      required: validationMessages.Required(),
                    })}
                  />
                  {isSubmitted && (
                    <FormErrorMessage
                      formControlName={"storeCode"}
                      errors={errors}
                    ></FormErrorMessage>
                  )}
                </Form.Group>
              </Form.Group>
            </Col>
          </Row>
        )}
        <Row>
          <Col className="d-flex align-items-center justify-content-center px-3">
            <img
              style={{ maxWidth: "400px" }}
              className="box w-100"
              src={process.env.PUBLIC_URL + "/img/device_bottom_code.png"}
              alt=""
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <Link
              to={getRegulationUrl(offerId)}
              target="_blank"
              rel="noreferrer"
            >
              {labels.ProgramRegulations()}
            </Link>
          </Col>
        </Row>
      </Container>
    </Form>
  );
}

export default TradeInDevice;
